import React, { FC, useContext } from 'react'
import { ChatContext } from '~/service/chatConn'
import { get } from '~/utils/api'
import { Wrapper } from './Wrapper'
import { v4 as uuidv4 } from 'uuid'

type Props = {
  disabled: boolean
  inputRef: React.MutableRefObject<HTMLTextAreaElement | undefined>
  aiLang: string
}

const completionType = 'answerCorrection'

const AnswerCorrection: FC<Props> = ({ disabled, inputRef, aiLang }) => {
  const { activeChat, aiCompletionStart } = useContext(ChatContext)

  const loading = activeChat.aiCompletion?.type === completionType

  return (
    <Wrapper
      disabled={loading || disabled}
      tabIndex={0}
      tip={intl.formatMessage({
        id: 'chat / input / auto correction',
      })}
      onClick={async () => {
        const requestId = uuidv4()

        aiCompletionStart(activeChat.id, requestId, completionType)

        get<string>(`chat/aiAnswerCorrection/${activeChat.id}`, {
          answer: inputRef.current?.value,
          requestId,
          aiLang,
        })
      }}
    >
      <span
        className={
          loading ? 'fa fa-spin fa-spinner-third' : 'far fa-spray-can-sparkles'
        }
      />
    </Wrapper>
  )
}

export default AnswerCorrection
